import { useGet } from "@albertine/api-client";
import type { Booking } from "../../common/types/Booking";
import type { Request } from "../../common/types/Request";
import { mapApiBookingToBooking } from "../../utils/booking.adapter";
import { mapApiRequestToRequest } from "../../utils/request.adapter";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";

type WithBookingProps = {
    bookingId: string;
    renderLoading?: React.JSX.Element;
    renderOnError: React.JSX.Element;
    children: (booking: Booking, request: Request) => React.JSX.Element;
};

function WithBookingAndRequest(props: WithBookingProps) {
    const { bookingId, children, renderLoading, renderOnError } = props;

    const {
        data: bookingData,
        isError: bookingError,
        isLoading: bookingLoading,
    } = useGet("booking", { param: { bookingId } });

    const requestId = bookingData?.requestId;

    const {
        data: requestData,
        isError: requestError,
        isLoading: requestLoading,
    } = useGet("request", { param: { id: requestId! } }, { enabled: !!requestId });

    if (bookingError || requestError) {
        return renderOnError;
    }

    if (bookingLoading || requestLoading || !bookingData || !requestData) {
        return renderLoading || <LoadingSpinner />;
    }

    const booking = mapApiBookingToBooking(bookingData);
    const request = mapApiRequestToRequest(requestData);

    return children(booking, request);
}

export default WithBookingAndRequest;
